import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["list"];
  static values = {
    inputSelector: String,
    childrenSelector: String,
    handle: String,
  };

  connect() {
    const scope = this;

    this.sortable = Sortable.create(this.listTarget, {
      handle: this.handleValue,
      forceFallback: true,
      onEnd: () => scope.onSort(),
    });

    this.element.addEventListener("cocoon:after-insert", () => scope.onSort());
    this.element.addEventListener("cocoon:after-remove", () => scope.onSort());
  }

  onSort() {
    const allItems = this.listTarget.querySelectorAll(this.childrenSelectorValue);

    allItems.forEach((item, index) => {
      const input = item.querySelector(this.inputSelectorValue);
      if (input) input.value = index;
    });
  }
}
